import mixinTrackerSession from 'shared/mixins/tracker-session';
import {searchToObject} from 'shared/javascripts/url-helpers';

const trackerPrakerjaMixin = {
  mixins: [mixinTrackerSession],
  data: () => ({
    sessionStorageKey: 'prakerja_session_id',
    source: null,
    prevRoute: null,
    trackerMapper: {
      landing: 'prakerja_list',
      search: 'prakerja_search',
      'gojek-landing': 'prakerja_list_gojek',
      'dynamic-section': 'prakerja_dynamic_section',
      detail: 'prakerja_detail',
      'checkout-form': 'prakerja_confirmation',
      'account-verification': 'prakerja_otp',
      tnc: 'prakerja_tnc',
      merchant: 'prakerja_merchant',
      merchants: 'prakerja_merchant',
      category: 'prakerja_category',
      categories: 'prakerja_category',
      'search-filter': 'prakerja_search_filter',
      'search-sort': 'prakerja_search_sort',
      'search-location': 'prakerja_search_location',
      'merchant-search-filter': 'prakerja_merchant_search_filter',
      'merchant-search-sort': 'prakerja_merchant_search_sort',
      'merchant-search-location': 'prakerja_merchant_search_location',
    },
    pageVisitTime: 0,
  }),
  computed: {
    referrer() {
      return this.trackerMapper[this.prevRoute] || this.prevRoute || '';
    },
  },
  watch: {
    $route: {
      handler(to, from) {
        if (from.name) this.sendLeaveTracker({routeName: from.name});
        this.pageVisitTime = new Date().getTime();
        this.prevRoute = from.name;
      },
      deep: true,
    },
  },
  created() {
    this.mixinSyncSessionId();
  },
  methods: {
    initPrakerjaTracker() {
      const locationSearch = searchToObject();
      const {from, source, referrer} = locationSearch;

      const directAccessTemplate = 'direct-access';
      this.source = source || from || referrer || null;

      const blReferrerFromPrakerja = document.referrer.includes(`${document.location.host}${process.env.BASE_PATH}`);

      if (!this.source) {
        const splittedPath = window.location.pathname.split(process.env.BASE_PATH) ?? [];
        const [fullpath] = splittedPath.slice(1);
        if (document.referrer && !blReferrerFromPrakerja) {
          this.source = document.referrer;
          this.$router.replace({path: fullpath, query: {source: document.referrer}})?.catch((e) => e);
        } else {
          this.source = directAccessTemplate;
        }
      }

      this.prevRoute = referrer || this.source;
      this.pageVisitTime = new Date().getTime();
    },
    sendLeaveTracker({routeName}) {
      const visitDuration = Math.floor((new Date().getTime() - this.pageVisitTime) / 1000);
      const payload = {
        evn: `vp_prakerja_leave`,
        event_name: this.trackerMapper[routeName],
        visit_duration: visitDuration,
        ui: window.USER.id36,
        session_id: this.mixinSessionId,
      };
      return this.$tracker.event(payload);
    },
  },
};

export default trackerPrakerjaMixin;
